import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
import { Grid } from "@mui/material";
import { AddButton } from "../bankDetails/components/bankAccountsContent";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import CompaniesUserTableContent from "./components/companiesUserTableContent";

function CompaniesUserTable() {
  return (
    <div>
      <TitleHolder style={{ paddingBottom: "0" }}>
        <Grid container spacing={1}>
          <Grid sx={{ whiteSpace: "nowrap" }} item xs={6}>
            Users
          </Grid>
          <Grid item xs={6}>
            <div style={{ textAlign: "right" }}>
              <AddButton
                style={{ backgroundColor: "#4059e5" }}
                replace
                to="/app/add-user"
              ></AddButton>
            </div>
          </Grid>
        </Grid>
      </TitleHolder>
      <br />
      <StepperContentHolder>
        <CompaniesUserTableContent />
      </StepperContentHolder>
    </div>
  );
}

export default CompaniesUserTable;
